import { Trans, useTranslation } from "react-i18next";
import image from '../../img/Stock/banner.png';
import Button from "../Button";

const Banner = () => {
    const { t } = useTranslation();
    return (
        <section className="open-sans relative mt-[90px] xl:mt-[180px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <h1 className="text-center sm:text-left open-sans text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                    <Trans
                        i18nKey="stock.1"
                        components={{ span: <span className="text-[#89BDFF]" /> }}
                    />
                </h1>
                <div className="bg-[#0C2780] md:min-h-[400px] min-h-[unset] xl:min-h-[446px] relative mt-[30px] w-[calc(100%+40px)] ml-[-20px] sm:w-[100%] sm:ml-0">
                    <img className="relative md:absolute z-[1] right-0 top-0 h-[230px] md:h-[100%] w-[100%] md:w-[calc(100%-460px)] xl:w-[723px] object-cover object-center" src={image} alt='' />
                    <div className="relative z-10 pt-[30px] pb-[65px] md:py-[50px] xl:py-[70px] px-[25px]">
                        <p className="sm:text-[16px] font-[300] text-[14px] max-w-[412px] text-[#fff]">
                            {t('stock.2')}
                        </p>
                        <p className="max-w-[412px] open-sans sm:text-[16px] font-[300] text-[14px] text-[#fff] sm:mt-[15px] mt-[13px]">
                            {t('stock.3')}
                        </p>
                        <Button className="mt-[40px]" color="#EFEFEF" text="#0C2780" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
